import { render } from "./BookingTable.vue?vue&type=template&id=ed5d7278&scoped=true"
import script from "./BookingTable.vue?vue&type=script&lang=js"
export * from "./BookingTable.vue?vue&type=script&lang=js"

import "./BookingTable.vue?vue&type=style&index=0&id=ed5d7278&scoped=true&lang=css"
import "./BookingTable.vue?vue&type=style&index=1&id=ed5d7278&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed5d7278"]])

export default __exports__